import { ControlButton, Edge, useReactFlow } from "@xyflow/react"
import { AppNode, EdgeData } from "@features/builder/graph/types"
import { useKeymap } from "@features/keymap/useKeymap"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { PlusIcon } from "@components/Icons/Plus"
import { shortcuts } from "@features/keymap/shortcuts"

export const ZoomInButton = () => {
  const reactFlowInstance = useReactFlow<AppNode, Edge<EdgeData>>()
  const keymap = useKeymap()

  const handleZoomIn = () => reactFlowInstance.zoomIn()

  return (
    <>
      <KeyBinding bind={shortcuts["zoom-in"]} onKeyDown={handleZoomIn} allowRepeat />
      <KeyBinding bind={shortcuts["zoom-in-secondary"]} onKeyDown={handleZoomIn} allowRepeat />
      <ControlButton
        data-testid="graph-controls-zoom-in-btn"
        onClick={handleZoomIn}
        title={keymap.getKeymaps().byId.get("zoom-in")?.desc}
      >
        <PlusIcon />
      </ControlButton>
    </>
  )
}
